/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { RoundSigPipe } from '../../../../../pipes/roundsig.pipe';
import { CustomItemContext } from 'app/components/data-table/data-table.component';
import { ChartData } from '../../../charts/models/ChartData';

@Component({
  selector: 'app-inventory',
  templateUrl: './app-inventory.html',
  styleUrls: ['./app-inventory.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppInventory implements OnInit, OnChanges {
  @Input() region;
  @Input() month;
  @Input() appName;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();

  @ViewChild('regionTemplate', { static: true })
  regionTemplate: TemplateRef<CustomItemContext>;
  @ViewChild('lockedTemplate', { static: true })
  lockedTemplate: TemplateRef<CustomItemContext>;
  @ViewChild('percentFormattedTemplate', { static: true })
  percentFormattedTemplate: TemplateRef<CustomItemContext>;
  @ViewChild('countryTemplate', { static: true })
  countryTemplate: TemplateRef<CustomItemContext>;

  _data;
  chartData: Object;

  toggle0 = false;
  toggle1 = false;
  toggle2 = false;
  toggle3 = false;

  headerCountries = [];
  headerRegions = [];
  headerStates = [];
  headerAdSizes = [];
  headerDmas = [];
  headerDevices = [];

  countries = [];
  regions = [];
  states = [];
  adSizes = [];
  dmas = [];
  devices = [];

  percPipe = new PercPipe();
  roundSig = new RoundSigPipe();

  topRegion: any;
  topAdSize: any;
  topDma: any;
  topDevice: any;

  lineChartData: Array<ChartData>;

  ngOnInit() {
    this.headerCountries.push({
      class: 'col-4',
      text: 'COUNTRY NAME',
      key: 'name',
      tooltipkey: ''
    });
    this.headerCountries.push({
      class: 'col',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      tooltipkey: ''
    });
    this.headerCountries.push({
      class: 'col',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      tooltipkey: ''
    });
    this.headerCountries.push({
      class: 'col',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    //
    this.headerStates.push({
      class: 'col-4',
      text: 'STATE',
      key: 'name',
      tooltipkey: ''
    });
    this.headerStates.push({
      class: 'col',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      tooltipkey: ''
    });
    this.headerStates.push({
      class: 'col',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      tooltipkey: ''
    });
    this.headerStates.push({
      class: 'col',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    //
    this.headerAdSizes.push({
      class: 'col-4',
      text: 'AD SIZE',
      key: 'adSize',
      tooltipkey: ''
    });
    this.headerAdSizes.push({
      class: 'col',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      tooltipkey: ''
    });
    this.headerAdSizes.push({
      class: 'col',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      tooltipkey: ''
    });
    this.headerAdSizes.push({
      class: 'col',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    //
    this.headerDmas.push({
      class: 'col-4',
      text: 'DMA NAME',
      key: 'name',
      tooltipkey: ''
    });
    this.headerDmas.push({
      class: 'col',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      tooltipkey: ''
    });
    this.headerDmas.push({
      class: 'col',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      tooltipkey: ''
    });
    this.headerDmas.push({
      class: 'col',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    //
    this.headerDevices.push({
      class: 'col-4',
      text: 'Device',
      key: 'deviceMarketingName',
      tooltipkey: ''
    });
    this.headerDevices.push({
      class: 'col',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      tooltipkey: ''
    });
    this.headerDevices.push({
      class: 'col',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      tooltipkey: ''
    });
    this.headerDevices.push({
      class: 'col',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    //
    this.headerRegions.push({
      class: 'col-4',
      text: 'Region',
      key: 'region',
      tooltipkey: ''
    });
    this.headerRegions.push({
      class: 'col',
      text: 'INVENTORY',
      format: 'percent',
      key: 'totalInventoryRatio',
      tooltipkey: ''
    });
    this.headerRegions.push({
      class: 'col',
      text: 'IVT',
      format: 'percent',
      key: 'givtSivtRate',
      tooltipkey: ''
    });
    this.headerRegions.push({
      class: 'col',
      text: 'VIEWABILITY',
      format: 'percent',
      key: 'viewability',
      tooltipkey: ''
    });
    // setTimeout(fn => {
    //     jQuery('[data-toggle="tooltip"]').tooltip({animation: false});
    // }, 100);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] || changes['isFreemium'] || changes['isFollowing']) {
      if (this.data['inventoryDistribution']['devices']) {
        this.devices = JSON.parse(
          JSON.stringify(this.data['inventoryDistribution']['devices'])
        );
        if (this.isFreemium) {
          if (!this.isFollowing) {
            if (this.devices && this.devices.length > 3) {
              this.devices = this.devices.slice(0, 3);
            }
          }
        }
        this.prepareHTML(this.devices);
        this.topDevice =
          this.devices && this.devices[0] ? this.devices[0] : null;
      }

      if (this.data['inventoryDistribution']['regions']) {
        this.regions = JSON.parse(
          JSON.stringify(this.data['inventoryDistribution']['regions'])
        );
        if (this.isFreemium) {
          if (!this.isFollowing) {
            if (this.regions && this.regions.length > 3) {
              this.regions = this.regions.slice(0, 3);
            }
          }
        }
        this.prepareHTML(this.regions);
        this.topRegion =
          this.regions && this.regions[0] ? this.regions[0] : null;
      }

      if (this.data['inventoryDistribution']['countries']) {
        this.countries = JSON.parse(
          JSON.stringify(this.data['inventoryDistribution']['countries'])
        );
        if (this.isFreemium) {
          if (!this.isFollowing) {
            if (this.countries && this.countries.length > 3) {
              this.countries = this.countries.slice(0, 3);
            }
          }
        }
        this.prepareHTML(this.countries);
      }

      if (this.data['inventoryDistribution']['states']) {
        this.states = JSON.parse(
          JSON.stringify(this.data['inventoryDistribution']['states'])
        );
        if (this.isFreemium) {
          if (!this.isFollowing) {
            if (this.states && this.states.length > 3) {
              this.states = this.states.slice(0, 3);
            }
          }
        }
        this.prepareHTML(this.states);
      }

      if (this.data['inventoryDistribution']['adSizes']) {
        this.adSizes = JSON.parse(
          JSON.stringify(this.data['inventoryDistribution']['adSizes'])
        );
        if (this.isFreemium) {
          if (!this.isFollowing) {
            if (this.adSizes && this.adSizes.length > 3) {
              this.adSizes = this.adSizes.slice(0, 3);
            }
          }
        }
        this.prepareHTML(this.adSizes);
        this.topAdSize =
          this.adSizes && this.adSizes[0] ? this.adSizes[0] : null;
      }

      if (this.data['inventoryDistribution']['dmas']) {
        this.dmas = JSON.parse(
          JSON.stringify(this.data['inventoryDistribution']['dmas'])
        );
        if (typeof this.dmas === 'string') {
          this.dmas = [];
        }
        if (this.isFreemium) {
          if (!this.isFollowing) {
            if (this.dmas && this.dmas.length > 3) {
              this.dmas = this.dmas.slice(0, 3);
            }
          }
        }
        this.prepareHTML(this.dmas);
        this.topDma = this.dmas && this.dmas[0] ? this.dmas[0] : null;
      }

      if (this?.data?.user?.byMonth) {
        this.lineChartData = this?.data?.user?.byMonth;
        this.lineChartData.reverse();
      }
    }
  }

  prepareHTML(data) {
    if (data && data !== 'N/A' && data.length > 0) {
      for (const dataItem of data) {
        if (typeof dataItem !== 'string') {
          // Modify region 'NA' as 'North America'
          dataItem['regionTemplate'] = this.regionTemplate;

          // Modify total inventory HTML to be displayed
          // {{seller.totalInventory | num}} <strong>({{seller.totalTrafficRatio | perc:'1.2-2'}})</strong>
          if (this.isFreemium) {
            dataItem['totalInventoryRatioTemplate'] = this.lockedTemplate;
          } else {
            dataItem['totalInventoryRatioTemplate'] =
              this.percentFormattedTemplate;
          }

          // Modify SIVT Rate HTML to be displayed
          // {{seller.givtSivtRate | perc:'1.2-2'}}
          if (this.isFreemium && !this.isFollowing) {
            dataItem['givtSivtRateTemplate'] = this.lockedTemplate;
          } else {
            dataItem['givtSivtRateTemplate'] = this.percentFormattedTemplate;
          }

          // Modify Viewability HTML to be displayed
          // {{seller.viewability | perc:'1.2-2'}}
          if (this.isFreemium) {
            dataItem['viewabilityTemplate'] = this.lockedTemplate;
          } else {
            dataItem['viewabilityTemplate'] = this.percentFormattedTemplate;
          }
          dataItem['nameTemplate'] = this.countryTemplate;
        } else {
          console.log('DATA: ' + dataItem);
        }
      }
    }
  }

  toggle(n) {
    this['toggle' + n] = !this['toggle' + n];
  }

  @Input()
  set data(value) {
    this._data = value;
    this.chartData = this.data['inventoryDistribution'].byMonth;
  }

  get data() {
    return this._data;
  }
}
